export default {
  setLanguage({ commit }, language) {
    commit('setLanguage', language)
  },
  setApiQuery({ commit }, o) {
    commit('setApiQuery', o)
  }
}
